export const getDishes = store => store.dishes
export const getDishesOriginal = store => store.dishes.original
export const getDishesEntities = store => store.dishes.entities
export const getDishesIds = store => store.dishes.ids

export const getDishesWithoutSizes = store =>
  store.dishes.original.filter(x => Number.isInteger(x.parentSizeId) === false)

export const getDishById = store => id => store.dishes.entities[id] || {}
